/**
 * Blog article data — single source of truth.
 * Generated by `python3 scripts/build_blog_posts.py` from hand-written prose +
 * real recipe data in scripts/_recipes.json. Consumed by <BlogPost> (React) and
 * scripts/prerender.cjs (static HTML), so both always match.
 */
import data from './blogPosts.json';

export const POSTS = data;

export const getPostBySlug = (slug) => POSTS.find((p) => p.slug === slug) || null;
